<template>
<el-dialog
  :visible='true'
  title=''
  :before-close='handleClose'
  width='540px'
  :close-on-click-modal='false'
>
  <div class="notShow">
    <img src="@/assets/images/未开通富信.png" alt="">
    <p>您还未开通卡片短信营销功能</p>
    <div class="bottom-btn">
      <button class="keep" style="width: 150px;" @click.prevent="toSubmit">
        去提交资质申请开通
      </button>
    </div>
  </div>
</el-dialog>
</template>

<script>

export default {
 name: '' ,
 components: {},
 props:{
  visible: {
    type: Boolean,
    default: false,
  },
 },
 data() {
 return {
 
 }
 },
 computed: {},
 created() {
 
 },
 mounted() {
 
 },
 methods: {
  handleClose() {
   this.$emit('close');
  },
  toSubmit() {
    // 跳转至  后台管理-富信资质
    this.$router.push({ name: 'media_qualification' })
  },
 }
}
</script>
<style lang='scss' scoped>
/deep/ .el-dialog__header{
  border-bottom:none;
}
/deep/ .el-dialog__body{
  padding-top: 0;
}
.keep {
  width: 98px;
  height: 32px;
  margin: 0 10px 0 8px;
  cursor: pointer;
  color: #ffffff;
  border-radius: 3px;
  border: 1px solid #fe4d45;
  background-color: #fe4d45;

  &:hover {
    color: #fff;
    opacity: 0.9;
    background-color: #fe4d45;
  }

  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}

.notShow {
  position: relative;
  text-align: center;
  top:-20px;
  img {
    width: 348px;
    height: 348px;
  }

  p {
    position: absolute;
    top: 328px;
    color: #999999;
    width: 100%;
    font-size: 14px;
    text-align: center;
  }

  .bottom-btn {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
}
</style>